import type { GraphEntityType, GraphEntityTypeV2, GraphVisualizationFrame } from "@salesko/contracts";
import { Hand } from "lucide-react";
import { lazy, Suspense, useMemo, useState } from "react";
import { useI18n } from "../../i18n";

const GraphCanvas = lazy(() =>
  import("../../components/GraphCanvas").then((module) => ({ default: module.GraphCanvas }))
);

type GraphFlatProps = {
  frame: GraphVisualizationFrame;
  filters: Record<GraphEntityType, boolean>;
  selectedNodeId: string | null;
  onSelectNode: (nodeId: string) => void;
};

const EntityTypes: GraphEntityType[] = ["person", "organisation", "event", "opportunity", "note"];

export function GraphFlat({ frame, filters, selectedNodeId, onSelectNode }: GraphFlatProps) {
  const { t } = useI18n();
  const [zoomLevel, setZoomLevel] = useState(1);
  const enabledEntityTypes = useMemo(
    () => EntityTypes.filter((type) => filters[type] !== false) as GraphEntityTypeV2[],
    [filters]
  );

  return (
    <div className="mk-graph">
      <Suspense fallback={<div className="mk-loading">{t.common.loading}</div>}>
        <GraphCanvas
          enabledEntityTypes={enabledEntityTypes}
          focusNodeId={selectedNodeId}
          frame={frame}
          matchNodeIds={[]}
          onSelectEdge={() => {}}
          onSelectNode={onSelectNode}
          onZoomChange={setZoomLevel}
          selectedEdgeId={null}
          selectedNodeId={selectedNodeId}
          spotlightNodeIds={[]}
          variant="mobile"
          viewMode="flat"
          zoomLevel={zoomLevel}
        />
      </Suspense>
      <div className="mk-graph-cap">
        <Hand size={13} color="var(--text-muted)" /> {t.mobile.graphCaption}
      </div>
    </div>
  );
}
